
/* injects from baggage-loader */

'use strict';

import config from './index.config';
import run from './index.run';

import uiRouter from '@uirouter/angularjs';

import coreModule from './core/core.module';
import indexComponents from './index.components';
import indexRoutes from './index.routes';
import loginModule from './pages/login/login.module';
import mainModule from './pages/main/main.module';
import pageTwoModule from './pages/page-two/page-two.module';
import pageFourModule from './pages/page-four/page-four.module';
import pageFiveModule from './pages/page-five/page-five.module';
import pageSixModule from './pages/page-six/page-six.module';
import pageSevenModule from './pages/page-seven/page-seven.module';
import pageEightModule from './pages/page-eight/page-eight.module';
import pageNineModule from './pages/page-nine/page-nine.module';
import pageTenModule from './pages/page-ten/page-ten.module';
// import fableOneModule from './pages/fable-one/fable-one.module';
// import fableTwoModule from './pages/fable-two/fable-two.module';


const App = angular.module(
  "template", [
    // plugins
    uiRouter,
    "ngAnimate", 
    "ngCookies", 
    "ngTouch", 
    "ngSanitize", 
    "ngMessages", 
    "ngAria",
    "ng-sortable",
    "ang-drag-drop",
    'ui.bootstrap',
    "focus-if",

    // core
    coreModule.name,

    // components
    indexComponents.name,

    // routes

    indexRoutes.name,

    // pages
    loginModule.name,
    mainModule.name,
    pageTwoModule.name,
    pageFourModule.name,
    pageFiveModule.name,
    pageSixModule.name,
    pageSevenModule.name,
    pageEightModule.name,
    pageNineModule.name,
    pageTenModule.name
    // fableOneModule.name,
    // fableTwoModule.name
    ]
    );

App
.config(config)
.run(run);



export default App;



// WEBPACK FOOTER //
// ./src/app/index.module.js